export default __webpack_public_path__ + "static/media/NO.d7983c4e.svg";